module.exports = __webpack_public_path__ + "img/1.2ecddc94.png";